<script>
  import { onMount } from "svelte";
  import { getAuth } from 'firebase/auth'
  import { collection, doc, getDocs, getFirestore, query, where } from 'firebase/firestore'

  let db = undefined
  let userId = undefined
  let challenges = []
  let games = []

  onMount(async () => {
    if(!db)
      db = getFirestore()
    if(!userId)
      userId = getAuth().currentUser.uid
    const userRef = doc(db, 'users', userId)
    const challengeQuery = query(collection(db, 'challenge'), where( "creator", '==', userRef))
    const challengeSnapshot = await getDocs(challengeQuery)
    const myChallenges = []
    challengeSnapshot.forEach((doc) => {
      myChallenges.push({ data: doc.data(), id: doc.id, ref: doc.ref })
    })

    await Promise.all(myChallenges.map(async(challengeGame, idx) => {
      const challengeGameQuery = query(collection(db, 'wordle'), where( "challenge", '==', challengeGame.ref))
      const challengeGameSnapshot = await getDocs(challengeGameQuery)
      const played = []
      challengeGameSnapshot.forEach(doc => {
        console.log(doc.data(), doc)
        played.push(doc.data())
      })
      myChallenges[idx].played = played
    }))
    challenges = myChallenges

    console.log('challenges', challenges)
    const gamesQuery = query(collection(db, 'wordle'), where( "player", '==', userRef))
    const gamesSnapshot = await getDocs(gamesQuery)
    const gArr = []
    gamesSnapshot.forEach(doc => {
      gArr.push({ data: doc.data(), id: doc.id, ref: doc.ref})
    })
    games = gArr
  })
  $: solvedGames = games.filter(game => game.data.solved)
  $: challengesPlayed = games.filter(game => game.data.challenge)
</script>

<div class="flex flex-col max-w-md mx-auto h-full">
  <div class="p-2 m-2 rounded-md">
    <div class="text-left">{ challenges.length } challenges created</div>
    {#each challenges as challenge }
      <div class="w-full h-full flex items-center justify-between border rounded-md text-lg my-1 p-2">
        <div>{window.atob(challenge.data.hashLink).split('+')[0]}</div>
        <div class="grid grid-cols-2 items-center mx-2">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-users" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <circle cx="9" cy="7" r="4" />
              <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
            </svg>
            <div class="ml-1">{challenge.played?.length || 0 }</div>
          </div>
          <div class="flex items-center ml-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trophy text-yellow-600" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
              <line x1="7" y1="4" x2="17" y2="4" />
              <path d="M17 4v8a5 5 0 0 1 -10 0v-8" />
              <circle cx="5" cy="9" r="2" />
              <circle cx="19" cy="9" r="2" />
            </svg>
            <div class="ml-1">{challenge.played.filter(p => p.solved).length || 0 }</div>
          </div>
        </div>
        
        <a href={`/#${challenge.data.hashLink}`} target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-external-link" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5" />
            <line x1="10" y1="14" x2="20" y2="4" />
            <polyline points="15 4 20 4 20 9" />
          </svg>
        </a>
      </div>
    {/each}
  </div>
  <div class="bg-teal-700 text-white p-2 m-2 rounded-md">
    <div>{ games.length } games played</div>
    {#each games as game }
      <div class="flex items-center justify-between">
        <div>{game.data.solved ? 'Solved' : 'Failed' }</div>
        <div>{new Date(game.data.seconds * 1000).toISOString().substr(14, 5) }</div>
      </div>
    {/each}
  </div>
</div>
  